import {
  IconCurrencyCircleDollar,
  IconGift,
  IconRows,
  IconTag,
  IconTruck,
} from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { IconFormula, IconMoney, IconPercent, IconStar } from 'ui'
import { RegularBenefitVariant } from '../../../../../typings'
import { Options } from '../../../../BenefitMenu'
import { messages } from './messages'
import {
  EMPTY_FORMULA,
  EMPTY_FREE_SHIPPING,
  EMPTY_MAX_PRICE,
  EMPTY_MAX_SHIPPING,
  EMPTY_NOMINAL_LOYALTY,
  EMPTY_NOMINAL_PRICE,
  EMPTY_NOMINAL_SHIPPING,
  EMPTY_PERCENTUAL_LOYALTY,
  EMPTY_PERCENTUAL_SHIPPING,
} from './Variants'
import { EMPTY_GIFT } from './Variants/Gift/constants'

const { discount } = messages

enum Section {
  Discount = 'discount',
  Shipping = 'shipping',
  Loyalty = 'loyalty',
}

export const BENEFIT_OPTIONS: Options = [
  {
    name: Section.Discount,
    Icon: IconTag,
    label: <FormattedMessage {...discount.discount} />,
    children: [
      {
        name: RegularBenefitVariant.Nominal,
        label: <FormattedMessage {...messages.nominal} />,
        sectionLabel: <FormattedMessage {...discount.nominal} />,
        Icon: IconMoney,
      },
      {
        name: RegularBenefitVariant.Percentual,
        label: <FormattedMessage {...messages.percentual} />,
        sectionLabel: <FormattedMessage {...discount.percentual} />,
        Icon: IconPercent,
      },
      {
        name: RegularBenefitVariant.Formula,
        label: <FormattedMessage {...messages.formula} />,
        sectionLabel: <FormattedMessage {...discount.formula} />,
        Icon: IconFormula,
      },
    ],
  },
  {
    name: Section.Shipping,
    label: <FormattedMessage {...discount.shipping} />,
    Icon: IconTruck,
    children: [
      {
        name: RegularBenefitVariant.NominalShipping,
        label: <FormattedMessage {...messages.nominal} />,
        sectionLabel: <FormattedMessage {...discount.nominalShipping} />,
        Icon: IconTruck,
      },
      {
        name: RegularBenefitVariant.PercentualShipping,
        label: <FormattedMessage {...messages.percentual} />,
        sectionLabel: <FormattedMessage {...discount.percentualShipping} />,

        Icon: IconTruck,
      },
      {
        name: RegularBenefitVariant.FreeShipping,
        label: <FormattedMessage {...messages.freeShipping} />,
        sectionLabel: <FormattedMessage {...discount.freeShipping} />,
        Icon: IconTruck,
      },
      {
        name: RegularBenefitVariant.MaxShipping,
        label: <FormattedMessage {...messages.maxShipping} />,
        sectionLabel: <FormattedMessage {...discount.maxShipping} />,
        Icon: IconTruck,
      },
    ],
  },
  {
    name: RegularBenefitVariant.MaxPrice,
    label: <FormattedMessage {...discount.maxPrice} />,
    Icon: IconCurrencyCircleDollar,
  },
  {
    name: RegularBenefitVariant.Gift,
    label: <FormattedMessage {...discount.gift} />,
    Icon: IconGift,
  },
  {
    name: Section.Loyalty,
    Icon: IconTag,
    label: <FormattedMessage {...discount.loyalty} />,
    children: [
      {
        name: RegularBenefitVariant.NominalLoyalty,
        label: <FormattedMessage {...messages.nominal} />,
        sectionLabel: <FormattedMessage {...discount.nominalLoyalty} />,
        Icon: IconStar,
      },
      {
        name: RegularBenefitVariant.PercentualLoyalty,
        label: <FormattedMessage {...messages.percentual} />,
        sectionLabel: <FormattedMessage {...discount.percentualLoyalty} />,
        Icon: IconStar,
      },
    ],
  },
  {
    name: RegularBenefitVariant.PriceTable,
    label: <FormattedMessage {...discount.priceTable} />,
    Icon: IconRows,
  },
]

export const EMPTY_BENEFIT: Record<RegularBenefitVariant, any> = {
  [RegularBenefitVariant.Nominal]: EMPTY_NOMINAL_PRICE,
  [RegularBenefitVariant.MaxPrice]: EMPTY_MAX_PRICE,
  [RegularBenefitVariant.Percentual]: {
    type: RegularBenefitVariant.Percentual,
    value: undefined,
  },
  [RegularBenefitVariant.Formula]: EMPTY_FORMULA,
  [RegularBenefitVariant.NominalShipping]: EMPTY_NOMINAL_SHIPPING,
  [RegularBenefitVariant.PercentualShipping]: EMPTY_PERCENTUAL_SHIPPING,
  [RegularBenefitVariant.FreeShipping]: EMPTY_FREE_SHIPPING,
  [RegularBenefitVariant.MaxShipping]: EMPTY_MAX_SHIPPING,
  [RegularBenefitVariant.Gift]: EMPTY_GIFT,
  [RegularBenefitVariant.NominalLoyalty]: EMPTY_NOMINAL_LOYALTY,
  [RegularBenefitVariant.PercentualLoyalty]: EMPTY_PERCENTUAL_LOYALTY,
  [RegularBenefitVariant.PriceTable]: {
    type: RegularBenefitVariant.PriceTable,
  },
}
